import React, {useState} from "react";
import {Box, Button, Paper, Stack, TextField, Typography} from "@mui/material";
import {useResendSeniorityMessageMutation} from "../../../core/api/seniority-api";
import ResponseDialog from "../../ResponseDialog";

export default function ServiceFunctions() {
    const [voucherId, setVoucherId] = useState("");
    const [isResponseDialogOpen, setIsResponseDialogOpen] = useState(false);
    const [resendSeniorityMessage, resendResponse] = useResendSeniorityMessageMutation();

    const handleResend = async () => {
        await resendSeniorityMessage({voucherId: voucherId.trim()});
        setIsResponseDialogOpen(true);
    };

    const handleResponseDialogClose = () => {
        setIsResponseDialogOpen(false);
    };

    return (
        <Box className='page-main-box'>
            <Typography variant="h5" sx={{pt: 2}}>
                Service functions
            </Typography>
            <Paper variant="outlined" sx={{p: 2, mt: 2, maxWidth: 600, borderRadius: 2}}>
                <Typography variant="h6">
                    Resend Seniority message
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{mt: 1}}>
                    The Seniority program message will be queued again for sending
                    via Slack to the employee who owns the voucher.
                </Typography>
                <Stack spacing={2} direction="row" sx={{mt: 2, alignItems: 'center'}}>
                    <TextField
                        label="Voucher Id"
                        size="small"
                        fullWidth
                        value={voucherId}
                        onChange={(event) => setVoucherId(event.target.value)}
                    />
                    <Button
                        variant="contained"
                        color="warning"
                        disabled={voucherId.trim() === "" || resendResponse.isLoading}
                        onClick={handleResend}
                    >
                        Send
                    </Button>
                </Stack>
            </Paper>
            <ResponseDialog
                onClose={handleResponseDialogClose}
                open={isResponseDialogOpen}
                responseData={resendResponse}
                label={"Service functions"}
                information={resendResponse.isSuccess
                    ? `Message for ${resendResponse.data && resendResponse.data.employeeEmail} has been queued for sending`
                    : ""}
            />
        </Box>
    );
}
